import React, { Component } from 'react';
import QrReader from 'react-qr-reader';
import { Redirect } from 'react-router-dom';

class MachineScanView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            delay: 300,
            result: 'No result',
        };
        this.handleScan = this.handleScan.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    handleScan(data) {
        if (data) {
            console.log(data.split('@@@'));
            this.setState({
                result: data,
            });
        }
    }

    handleError(err) {
        console.error(err);
        return this;
    }

    toggle() {
        const { toggle } = this.state;
        this.setState({
            toggle: !toggle,
        });
    }

    render() {
        let machineid = null;
        if (this.state.result != null) {
            machineid = this.state.result.split('@@@')[1];
        }

        return (
            <div className="card">
                <div className="card-header">
                    Lector de QR
                </div>
                <div className="card-body">

                    <button type="submit" onClick={this.toggle}>
                        {this.state.toggle ? 'disable' : 'enable'}
                    </button>
                    <br />
                    { this.state.toggle
                        && (
                            <QrReader
                                delay={this.state.delay}
                                onError={this.handleError}
                                onScan={this.handleScan}
                                style={{ width: '50%' }}
                            />
                        )
                    }
                    { machineid != null
                        && (
                            <Redirect to={`/machine/${machineid}`} />
                        )
                    }
                </div>
            </div>
        );
    }
}

export default MachineScanView;



// WEBPACK FOOTER //
// ./src/components/views/MachineScanView.js